import { useState } from 'react';
import { SvgIcon } from '../../../../common/components/SvgIcon';
import { useSgwtTranslation } from '../../../../common/i18n';
import { useBotConversation } from '../../shared/BotConversationContext';
import type { UserFeedback } from '../../shared/chatbot.types';
import { ExpandableTextField } from '../layout/InputField';

export const UserReaction = ({ action }: { action: UserFeedback }) => {
  const { translate } = useSgwtTranslation();
  const { cancelFeedback, sendFeedback } = useBotConversation();
  const [text, setText] = useState('');

  const handleSend = (text: string) => {
    sendFeedback({
      ...action,
      explanations: text,
    });
  };

  const { reaction, status } = action;

  if (status === 'submitted') {
    const color = reaction === 'like' ? 'success' : 'danger';
    return (
      <section
        className={`sgwt-chatbot-message sgwt-chatbot-message-user border-end border-lg border-${color} bg-${color} bg-opacity-05 mb-5 p-12px`}
      >
        <div className={`text-${color}`}>
          <SvgIcon type={reaction === 'like' ? 'thumb_up' : 'thumb_down'} height={16} width={16} />
          <span className="ms-2">{translate(`feedback.submitted.${reaction}`)}</span>
        </div>
        <div className="mt-1 ps-4 d-flex flex-column">{action.explanations}</div>
      </section>
    );
  }

  const isLoading = status === 'submitting';
  const isError = status === 'error';

  return (
    <section className="sgwt-chatbot-message sgwt-chatbot-interaction mb-5 p-12px">
      <div className="mb-2">{translate(`feedback.${reaction}`)}</div>

      <ExpandableTextField onSend={handleSend} disabled={isLoading} onValueChange={setText} size="md" includeSendButton={false} clearOnSend={false} />

      <div className="d-flex justify-content-end align-items-center mt-2 gap-2">
        {isError && <span className="text-danger flex-grow-1">{translate('feedback.error')}</span>}
        {isLoading ? (
          <div className="spinner spinner-sm my-2" />
        ) : (
          <>
            <button type="button" className="btn btn-flat-secondary btn-icon" onClick={() => cancelFeedback(action)}>
              <SvgIcon type="close" />
            </button>
            <button type="button" className="btn btn-success btn-icon" disabled={!text} onClick={() => handleSend(text)}>
              <SvgIcon type="send" />
            </button>
          </>
        )}
      </div>
    </section>
  );
};
